import { render, staticRenderFns } from "./new-driver-form.vue?vue&type=template&id=2eca80a0&"
import script from "./new-driver-form.vue?vue&type=script&lang=js&"
export * from "./new-driver-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports